<template>
  <div>
    <el-row type="flex" justify="center">
    <el-col
        class="dictionary-form-container"
        :span="22"
    >
      <el-row>
        <el-row>
          <h4>{{ title }}</h4>
        </el-row>
        <el-form>
          <el-form-item label="Название">
            <div v-if="$store.getters.user.role.name !=='admin' && selectedDictionary.type === 'system'">
              <div>{{ selectedDictionary.name }}</div>
            </div>
            <div v-else>
              <el-input
                  type="text"
                  placeholder="Введите название"
                  v-model="selectedDictionary.name"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="Описание">
            <div v-if="$store.getters.user.role.name !=='admin' && selectedDictionary.type === 'system'">
              <div>{{ selectedDictionary.description }}</div>
            </div>
            <div v-else>
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="Введите описание"
                  v-model="selectedDictionary.description">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="Запрос">
            <div
                v-if="$store.getters.user.role.name !=='admin' && selectedDictionary.type === 'system' || selectedDictionary.from_system_dictionary">
              <div>Системные данные скрыты</div>
            </div>
            <div v-else>comments
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="Введите описание"
                  v-model="selectedDictionary.query">
              </el-input>
            </div>


          </el-form-item>
          <el-form-item label="Положительный вес"
          >
            <el-input
                type="number"
                min="0"
                max="100"
                v-model="selectedDictionary.positive_weight"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="Отрицательный вес"
          >
            <el-input
                type="number"
                min="0"
                max="100"
                v-model="selectedDictionary.negative_weight"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="Реверс">
            <el-switch
                v-model="selectedDictionary.reverse"
                :active-value="1"
                :inactive-value="0"
            />
          </el-form-item>
          <el-form-item label="Поиск в канале 1">
            <el-switch
                v-model="selectedDictionary.search_in_channel_1"
                :active-value="1"
                :inactive-value="0"
            />
          </el-form-item>
          <el-form-item label="Поиск в канале 2">
            <el-switch
                v-model="selectedDictionary.search_in_channel_2"
                :active-value="1"
                :inactive-value="0"
            />
          </el-form-item>
          <el-form-item
              v-if="$store.getters.user.role.name === 'admin'"
              label="Системный"
          >
            <el-switch
                v-model="dictionaryType"
                :disabled="selectedDictionary.type === 'system'"
                :active-value="'system'"
                :inactive-value="'client'"
            />
          </el-form-item>

          <el-form-item label="Искать во входящих:">
            <el-switch
                v-model="selectedDictionary.search_in_call"
                :active-value="1"
                :inactive-value="0"
            />
          </el-form-item>
          <el-form-item label="Искать в исходящих:">
            <el-switch
                v-model="selectedDictionary.search_out_call"
                :active-value="1"
                :inactive-value="0"
            />
          </el-form-item>

          <el-form-item label="Цвет">
            <el-color-picker v-model="selectedDictionary.color_success"/>
          </el-form-item>
          <el-form-item label="Цвет 'не найдено'">
            <el-color-picker v-model="selectedDictionary.color_reject"/>
          </el-form-item>
          <el-form-item label="Отображать на главной странице">
            <el-switch
                v-model="selectedDictionary.in_dashboard"
                :active-value="1"
                :inactive-value="0"
            />
          </el-form-item>
          <el-form-item class="buttons">
            <div class="buttons-grid">
                <div>
                  <el-button @click="showDictionaryHistory()"><i class="el-icon-more"></i> История</el-button>
                </div>
                <div>
                  <el-button plain round @click="cancel">Отмена</el-button>
                  <el-button type="primary" :disabled="loading" round @click="save">{{ loading ? 'Работаю...' : 'Сохранить' }}</el-button>
                </div>
              </div>
          </el-form-item>
        </el-form>
      </el-row>

      <el-row class="command-buttons">

      </el-row>
    </el-col>


  </el-row>
   <el-dialog
        :visible.sync="historyVisible"
        width="85%"
        title="История изменений"
    >
      <div v-if="!computedHistory.length"> История остутствует</div>
      <el-collapse v-else v-model="activeHistory" @change="">
        <el-collapse-item v-for="history in computedHistory" :title="history.who_updated_name + ' - ' + history.updated_at + ': ' + history.name">
          <div class="dictionary-history">
            <div class="left">
              <div>
                <p>Название</p>
                <p>Описание</p>
                <p>Положительный вес</p>
                <p>Отрицательный вес</p>
                <p>Реверс</p>
                <p>Поиск в канале 1</p>
                <p>Поиск в канале 2</p>
                <p>Искать во входящих</p>
                <p>Искать в исходящих</p>
                <p>Цвет</p>
                <p>Цвет 'не найдено'</p>
              </div>
              <div>
                  <p>{{history.name}}</p>
                  <p>{{history.description}}</p>
                  <p>{{history.positive_weight}}</p>
                  <p>{{history.negative_weight}}</p>
                  <p>{{history.reverse}}</p>
                  <p>{{history.search_in_channel_1}}</p>
                  <p>{{history.search_in_channel_2}}</p>
                  <p>{{history.search_in_call}}</p>
                  <p>{{history.search_out_call}}</p>
                  <p>{{history.color_success}}</p>
                  <p>{{history.color_reject}}</p>

              </div>
            </div>
            <div class="right">
              <div>
                <p>Запрос</p>
              </div>
              <div>{{history.query}}</div>
            </div>

          </div>
        </el-collapse-item>
      </el-collapse>


    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "dictionary-form",
  props: {
    selectedDictionary: {},
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dictionaryType: 'client',
      historyVisible: false,
      activeHistory:[],
    }
  },
  mounted() {

    // if(!Object.keys(this.selectedDictionary).length === 0) {
    //   this.selectedDictionary.reverse = 0;
    //   this.selectedDictionary.type = 'client'
    // }
  },
  computed: {
    title() {
      this.dictionaryType = this.selectedDictionary.type
      return this.selectedDictionary.id
          ? 'Редактирование словаря ' + "\"" + this.selectedDictionary.name + "\""
          : 'Добавление словаря'
    },
    computedHistory() {
      return this.selectedDictionary?.history?.length ? this.selectedDictionary.history : []
    },
  },
  methods: {
    showDictionaryHistory() {
      this.historyVisible = true
    },
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.selectedDictionary.change_to_type = this.dictionaryType;
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>

.dictionary-form-container {
  h4 {
    text-align: center;
    margin-bottom: 10px;
  }

  ::v-deep .el-form {
    background: #fff;
    padding: 20px;
    border-radius: 4px;

    &-item {
      margin-bottom: 20px;

      &__label {
        font-weight: bold;
        line-height: 1;
      }

      &__content {
        line-height: 1;

        .el-switch {
          margin-top: -4px;
        }

        .el-color-picker {
          margin-top: -15px;
        }
      }
    }
  }

  .buttons {
    text-align: right;
    margin-bottom: 25px;
    .buttons-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      > div:first-child {
        text-align: left;
      }
    }
  }
}


::v-deep .el-collapse-item {
  &__content, p {
    color: black;
  }
  .dictionary-history {
    display: grid;
    grid-template-columns: 50% 50%;
    padding: 0 0.5rem;
    .left {
      display: flex;
      gap: 2rem;
      border: 1px solid #f0f0f0;
      border-radius: 3px;
      padding: 1rem;
      background: #f6f6f6;
    }
    .right {
      background: #f9f9f9;
      overflow: auto;
      padding: 1rem 0.5rem;
      margin: 0.5rem 0;
      border-radius: 3px;
      border: 1px solid #f0f0f0;
    }
  }

}





</style>
